export default "__VITE_ASSET__39a9cfc3__"